var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    cardRoot: true,
    isMoving: _vm.movingId && _vm.movingId !== _vm.id,
    isSelected: _vm.selected,
    isDisabled: _vm.disabled,
    isImage: _vm.isImage(_vm.value),
    isTable: _vm.isTable(_vm.value),
    isYoutube: _vm.isYoutube(_vm.value),
    isTwitter: _vm.isTwitter(_vm.value),
    isEditing: _vm.editing,
    isOutside: _vm.x < 0 || _vm.x > _vm.CANVAS_WIDTH || _vm.y < 0 || _vm.y >  _vm.CANVAS_HEIGHT
  },style:({
    left: (_vm.x + "px"),
    top: (_vm.y + "px"),
    height: ((_vm.height - _vm.DRAG_WIDTH * 2 + _vm.BORDER_WIDTH * 2) + "px")
  }),attrs:{"id":_vm.id},on:{"dblclick":_vm.stopEvent}},[_c('div',{ref:"card",staticClass:"card",style:({
      transform: _vm.movingId && _vm.movingId !== _vm.id && _vm.selected 
        ? ("translate(" + (_vm.diff.x) + "px, " + (_vm.diff.y) + "px)")
        : undefined,
      'background-color': _vm.getColor()['background-color'],
      'border-color': _vm.selected ? _vm.selectColor : _vm.getColor()['border-color'],
      'outline': _vm.selected ? ("solid 1px " + _vm.selectColor) : undefined,
      'min-height': !_vm.value ? _vm.UNIT * 3 : undefined,
      width: _vm.isImage(_vm.value) ? ((_vm.width - (_vm.DRAG_WIDTH * 2 + _vm.BORDER_WIDTH * 2)) + "px") : undefined,
      height: _vm.isImage(_vm.value) ? ((_vm.height - (_vm.DRAG_WIDTH * 2 + _vm.BORDER_WIDTH * 2)) + "px") : undefined
    }),on:{"click":_vm.onClick}},[_c('CardInner',{attrs:{"type":_vm.getType({ value: _vm.value, html: _vm.html, url: _vm.url, color: _vm.color }),"value":_vm.value,"html":_vm.html,"handleImageMeasure":_vm.onImageMeasure,"handleHTMLMeasure":_vm.onHTMLMeasure,"handleURL":_vm.onURL}}),(_vm.editing)?_c('CardInput',{staticClass:"input",attrs:{"initial":_vm.value,"isNew":_vm.id.match(/^new$/),"handleSubmit":_vm.submit,"handleBlur":_vm.blur}}):_vm._e()],1),(_vm.show)?_c('Drag',{staticClass:"card-draggable",attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y,"onDragging":_vm.onDragging,"onDragStop":_vm.handleStop}}):_vm._e(),(_vm.disabled)?_c('div',{staticClass:"disabled-text"},[_vm._v("selected by someone")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }